<template>
  <div id="direct-payment-edit-amount">
    <v-row>
      <v-col id="direct-payment-edit-amount-title">
        <h2>
          {{ $t('directPayments.reviewAndComplete.amount.heading') }}
        </h2>
      </v-col>
    </v-row>

    <v-row
      justify="space-between"
      justify-sm="start"
    >
      <v-col
        id="direct-payment-edit-amount-label"
        cols="auto"
        class="hidden-xs-only"
      >
        {{ $t('directPayments.reviewAndComplete.amount.label') }}
      </v-col>

      <v-spacer
        class="hidden-xs-only"
      />

      <v-col
        :cols="isEditAmountBtnLarge ? 12 : 'auto'"
        sm="auto"
        class="font-size-xl"
      >
        <validation-observer ref="obs">
          <transition name="slide-fade">
            <amount-variable-input
              v-if="isEditingAmount"
              v-model="editAmount"
              class="pb-8"
              :item="selectedItem"
            />
          </transition>

          <transition
            enter-class="fade-enter"
            enter-active-class="fade-enter-active transition-delay-7"
            enter-to-class="fade-enter-to"
            leave-class="d-none"
          >
            <span
              v-show="!isEditingAmount"
              id="direct-payment-edit-amount-value-read-only"
            >
              {{ displayAmount }}
            </span>
          </transition>
        </validation-observer>
      </v-col>

      <v-col
        :cols="isEditAmountBtnLarge ? 12 : 'auto'"
        sm="auto"
      >
        <tc-v-btn
          id="direct-payment-edit-amount-btn"
          class="font-size-lg"
          color="primary"
          :disabled="hasErrors"
          :block="isEditAmountBtnLarge"
          :large="isEditAmountBtnLarge"
          :outlined="isEditAmountBtnLarge"
          text
          @click="editAmountBtnClicked"
        >
          <v-icon v-if="!isEditingAmount">
            mdi-pencil
          </v-icon>

          {{ amountButtonText }}
        </tc-v-btn>
      </v-col>
    </v-row>

    <v-divider
      class="mb-15"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AmountVariableInput from '@/components/reward/details/AmountVariableInput'
import { ValidationObserver } from 'vee-validate'
import * as getTypes from '@/store/get-types'
import * as actionTypes from '@/store/action-types'

export default {
  name: 'DirectPaymentEditAmount',
  components: {
    AmountVariableInput,
    ValidationObserver
  },
  data: () => ({
    editAmount: null,
    isEditingAmount: false
  }),
  computed: {
    ...mapGetters({
      catalogItems: getTypes.GET_CATALOG_ITEMS,
      paymentAmount: getTypes.GET_DIRECT_PAYMENT_AMOUNT,
      paymentUtid: getTypes.GET_DIRECT_PAYMENT_UTID
    }),
    amountButtonText () {
      const field = this.isEditingAmount ? 'updateButtonText' : 'editButtonText'
      return this.$t(`directPayments.reviewAndComplete.${field}`)
    },
    displayAmount () {
      const { currencyCode } = this.selectedItem
      return this.$money(this.paymentAmount, currencyCode)
    },
    hasErrors () {
      const errors = this.errors?.items || []

      return errors.length > 0
    },
    isEditAmountBtnLarge () {
      return this.$vuetify.breakpoint.xsOnly && this.isEditingAmount
    },
    selectedItem () {
      return this.catalogItems.get(this.paymentUtid)
    }
  },
  methods: {
    ...mapActions({
      setPaymentAmount: actionTypes.SET_DIRECT_PAYMENT_AMOUNT
    }),
    editAmountBtnClicked () {
      if (this.isEditingAmount) {
        if (this.hasErrors) return

        this.setPaymentAmount(Number(this.editAmount).toFixed(2))
      } else {
        this.editAmount = Number(this.paymentAmount).toFixed(2)
      }
      this.isEditingAmount = !this.isEditingAmount
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin ingo-iframe-font {
  font-family: "Roboto", sans-serif !important;
  color: #22292F !important;
}

#direct-payment-edit-amount {
  @include ingo-iframe-font;

  #direct-payment-edit-amount-label {
    font-size: .875em;
  }

  #direct-payment-edit-amount-btn {
    min-width: 6em;
  }

  ::v-deep {
    .error-block {
      position: absolute;
      padding-right: 10px;
    }

    h2 {
      @include ingo-iframe-font;
      font-weight: 500;
    }
  }
}
</style>
